let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ag0E9")).then(() => parcelRequire('79ZX9'));